import axios from 'src/api/Api';
import {
    GET_INVENTORY_DATA_SUCCESS,
    GET_INVENTORY_DATA_FAILURE,
} from '../actions';
import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* getInventoryDetails(action) {
    const productType = action.payload ? action.payload.productType : '';
    const accountNumber = action.payload ? action.payload.accountNumber : '';
    const currentPage = action.payload ? action.payload.currentPage : '';
    const orderType = action.payload ? action.payload.orderType : '';
    const resourceType = action.payload ? action.payload.resourceType : '';
    const sortCode = action.payload ? action.payload.sortCode : '';
    const sortOrder = action.payload ? action.payload.sortOrder : '';
    const filterParam = action.payload ? action.payload.filterParam : '';
    const searchQuery = action.payload ? action.payload.searchQuery : '';
    const pageSize = action.payload ? action.payload.pageSize : '';
    const checkedItems = action.payload ? action.payload.checkedItems : '';
    const url = `occ/v2/${localStorage.getItem('baseSiteId')}/consignment/inventory?productType=${productType}&accountNumber=${accountNumber}&currentPage=${currentPage}&orderType=${orderType}&pageSize=${pageSize}&resourceType=${resourceType}&sortCode=${sortCode}&sortOrder=${sortOrder}&filterParam=${filterParam}&searchQuery=${searchQuery}`;
    try {
        const result = yield axios({
            method: 'get',
            url: url,
        }).then((response) => response.data);
        if (checkedItems) {
            result?.inventoryListDTO?.map((product) => {
                product.isChecked = checkedItems
                    .filter((item) => item.uniqueKey == product.uniqueKey)
                    .map((filteredValue) => filteredValue.isChecked)
                    .toString();
            });
        }

        yield put({
            type: GET_INVENTORY_DATA_SUCCESS,
            payload: result,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_INVENTORY_DATA_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
